"use client";

import { Suspense } from "react";
import { useOAuthErrorHandling } from "../hooks/useOAuthErrorHandling";

/**
 * Internal component that uses useSearchParams.
 * Must be wrapped in Suspense to prevent client-side rendering de-optimization.
 */
function OAuthErrorHandler() {
  useOAuthErrorHandling();
  return null;
}

/**
 * Wrapper component that handles OAuth errors from URL parameters.
 * Includes Suspense boundary to maintain Next.js static optimization.
 */
export function OAuthErrorBoundary() {
  return (
    <Suspense fallback={null}>
      <OAuthErrorHandler />
    </Suspense>
  );
}
